(function () {
  if (window.ossRecommendationEvents) return;
  var seen = new Set();
  var watched = new Map();
  var sequence = 0;
  var observer;
  var ga4Enabled = true;
  var ga4Target = 'G-3YK2PMZHTY';
  var ga4Pending = [];
  var ga4Sent = new Set();
  var ga4Sender;
  var ga4Timer;
  var ga4NextCheck = 0;

  function allowed() {
    var privacy = window.Shopify && Shopify.customerPrivacy;
    return !!(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
  }
  function flushGa4() {
    clearTimeout(ga4Timer);
    ga4Timer = null;
    if (!ga4Enabled || !allowed()) {
      ga4Pending = [];
      ga4Sender = null;
      return;
    }
    var now = Date.now();
    ga4Pending = ga4Pending.filter(function (entry) { return entry.expires > now; });
    if (!ga4Pending.length) return;
    if (typeof window.gtag !== 'function' || ga4Sender !== window.gtag) {
      if (typeof window.gtag === 'function' && now >= ga4NextCheck) {
        ga4NextCheck = now + 2000;
        var candidate = window.gtag;
        try {
          candidate('get', ga4Target, 'client_id', function (clientId) {
            if (!clientId || !allowed() || window.gtag !== candidate) return;
            ga4Sender = candidate;
            clearTimeout(ga4Timer);
            ga4Timer = setTimeout(flushGa4, 0);
          });
        } catch (error) {}
      }
      ga4Timer = setTimeout(flushGa4, 500);
      return;
    }
    var pending = ga4Pending;
    ga4Pending = [];
    pending.forEach(function (entry) {
      if (!allowed() || ga4Sent.has(entry.id)) return;
      try {
        ga4Sender('event', entry.name, entry.params);
        ga4Sent.add(entry.id);
      } catch (error) {}
    });
  }
  function forwardGa4(action, payload) {
    if (!ga4Enabled || !allowed() || ['impression', 'click', 'open_pack', 'add_success'].indexOf(action) === -1) return;
    if (ga4Sent.has(payload.event_id) || ga4Pending.some(function (entry) { return entry.id === payload.event_id; })) return;
    var params = { send_to: ga4Target };
    ['location', 'product_id', 'variant_id', 'quantity', 'value', 'currency', 'source', 'index', 'amount_basis', 'event_id', 'theme_id', 'theme_role', 'schema_version', 'action', 'displayed_value', 'line_quantity', 'line_value', 'cart_value', 'cart_value_delta'].forEach(function (key) {
      var value = payload[key];
      if (typeof value === 'string' || (typeof value === 'number' && Number.isFinite(value))) params[key] = value;
    });
    var query = new URLSearchParams(window.location.search);
    var qa = query.get('oss_qa') || '';
    if (/^aov_rec_[a-z0-9_]{1,48}$/.test(qa)) {
      params.qa_test = qa;
      if (query.get('oss_rec_debug') === '1') params.debug_mode = true;
    }
    if (ga4Pending.length >= 50) ga4Pending.shift();
    ga4Pending.push({ id: payload.event_id, name: 'oss_recommendation_' + action, params: params, expires: Date.now() + 20000 });
    flushGa4();
  }
  function context(node) {
    var card = node && node.closest('[data-oss-recommendation]');
    if (!card) return null;
    return {
      location: card.dataset.recLocation,
      product_id: String(card.dataset.recProductId || ''),
      variant_id: String(card.dataset.recVariantId || ''),
      quantity: 1,
      value: Number(card.dataset.recPriceCents || 0) / 100,
      currency: card.dataset.recCurrency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      source: card.dataset.recSource,
      index: Array.from(card.parentNode.querySelectorAll(':scope > [data-oss-recommendation]')).indexOf(card) + 1,
      amount_basis: 'displayed_variant_price'
    };
  }
  function publish(action, data) {
    if (!data || !allowed() || !window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return false;
    try {
      var payload = Object.assign({}, data, {
        event_id: 'oss-rec-' + Date.now() + '-' + (++sequence),
        theme_id: String(Shopify.theme && Shopify.theme.id || ''),
        theme_role: Shopify.theme && Shopify.theme.role || '',
        schema_version: 1
      });
      var result = Shopify.analytics.publish('oss_recommendation_' + action, payload);
      if (result && typeof result.catch === 'function') result.catch(function () {});
      if (result !== false) forwardGa4(action, payload);
      return result !== false;
    } catch (error) { return false; }
  }
  function visible(card) {
    if (!card.isConnected || document.visibilityState !== 'visible' || card.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    var style = getComputedStyle(card);
    return style.display !== 'none' && style.visibility !== 'hidden' && card.getBoundingClientRect().width > 0;
  }
  function observe(root) {
    if (!observer || !root) return;
    watched.forEach(function (state, card) {
      if (!card.isConnected) {
        clearTimeout(state.timer);
        observer.unobserve(card);
        watched.delete(card);
      }
    });
    root.querySelectorAll('[data-oss-recommendation]').forEach(function (card) {
      if (watched.has(card)) return;
      watched.set(card, { timer: null, ratio: 0 });
      observer.observe(card);
    });
  }
  function track(action, node, extra) {
    return publish(action, Object.assign(context(node) || {}, extra || {}));
  }
  function added(data, variantId, quantity, cart, response, before) {
    try {
      var line = cart && cart !== before && cart.items && cart.items.find(function (item) { return String(item.variant_id) === String(variantId); });
      var confirmed = !!line;
      var basis = 'confirmed_cart_line_price_allocated';
      if (!line) {
        line = response && (response.items ? response.items.find(function (item) { return String(item.id) === String(variantId); }) : response);
        basis = 'cart_add_response_line_price_allocated';
      }
      if (!line || !line.quantity) return;
      var lineAmount = Number.isFinite(line.line_price) ? line.line_price : null;
      if (lineAmount === null && Number.isFinite(line.original_line_price) && Number.isFinite(line.total_discount)) {
        lineAmount = line.original_line_price - line.total_discount;
        basis = confirmed ? 'confirmed_cart_original_less_discount_allocated' : 'cart_add_response_original_less_discount_allocated';
      }
      if (lineAmount === null || lineAmount < 0) return;
      publish('add_success', Object.assign({}, data, {
        variant_id: String(variantId), quantity: quantity,
        value: Math.round(lineAmount * quantity / line.quantity) / 100,
        displayed_value: data.value,
        line_quantity: line.quantity, line_value: lineAmount / 100,
        cart_value: confirmed && Number.isFinite(cart.total_price) ? cart.total_price / 100 : null,
        cart_value_delta: confirmed && before && Number.isFinite(before.total_price) ? (cart.total_price - before.total_price) / 100 : null,
        currency: cart && cart.currency || data.currency,
        amount_basis: basis
      }));
    } catch (error) {}
  }
  function cartConfirmed(cart) {
    var ids = (cart.items || []).map(function (item) { return String(item.product_id); });
    document.querySelectorAll('[data-rec-location="product_page"]').forEach(function (card) {
      card.hidden = ids.indexOf(card.dataset.recProductId) !== -1;
    });
    document.querySelectorAll('.oss-related-row').forEach(function (row) {
      row.hidden = !row.querySelector('[data-rec-location="product_page"]:not([hidden])');
    });
    observe(document);
  }
  window.ossRecommendationEvents = { context: context, observe: observe, track: track, added: added, cartConfirmed: cartConfirmed, refresh: refreshVisibility };

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var card = entry.target;
        var state = watched.get(card);
        if (!state) return;
        state.ratio = entry.intersectionRatio;
        clearTimeout(state.timer);
        if (state.ratio < 0.5 || !allowed() || !visible(card)) return;
        state.timer = setTimeout(function () {
          var data = context(card);
          if (!data || state.ratio < 0.5 || !visible(card)) return;
          var key = [data.location, data.product_id, data.variant_id].join(':');
          if (seen.has(key)) return;
          if (publish('impression', data)) seen.add(key);
        }, 1000);
      });
    }, { threshold: [0, 0.5] });
  }
  document.addEventListener('click', function (event) {
    var action = event.target.closest('a, [data-oss-global-quick-add], [data-oss-ajax-cart-recommendation-add]');
    if (!action || action.disabled || !context(action)) return;
    track('click', action, { action: action.matches('a') ? 'product_link' : action.matches('[data-oss-global-quick-add]') ? 'quick_add' : 'direct_variant_add' });
  }, true);
  function refreshVisibility() {
    observe(document);
    if (!observer) return;
    watched.forEach(function (state, card) {
      clearTimeout(state.timer);
      observer.unobserve(card);
      observer.observe(card);
    });
  }
  document.addEventListener('visitorConsentCollected', refreshVisibility);
  document.addEventListener('visibilitychange', refreshVisibility);
  document.addEventListener('oss:cart-updated', function () { observe(document); });
  function initialize() {
    observe(document);
    if (window.Shopify && Shopify.customerPrivacy) refreshVisibility();
    else if (window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) refreshVisibility();
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
